import Vue from 'vue'
import axios from 'axios'
import store from '@/store'

export default function(baseURL) {
	const http = axios.create({ baseURL });

	let axiosPeticiones = 0;

	http.interceptors.request.use(config => {
		if (store.state.auth && store.state.auth.token) {
			let token = store.state.auth.token;
			config.headers.Authorization = 'Bearer '+token;
		}

		let showSpinner = typeof(config.spinner) == 'undefined' ? true : config.spinner;

		if (axiosPeticiones == 0 && document.querySelectorAll('.loading').length > 0) {
			document.querySelectorAll('.loading')[0].style.display = 'block';
		}

		axiosPeticiones++;

		return config;
	});

	http.interceptors.response.use(response => {
		axiosPeticiones--;

		if (axiosPeticiones == 0 && document.querySelectorAll('.loading').length > 0) {
			document.querySelectorAll('.loading')[0].style.display = 'none';
		}

		return response;
	}, async (err) => {
		axiosPeticiones--;

		if (axiosPeticiones == 0 && document.querySelectorAll('.loading').length > 0) {
			document.querySelectorAll('.loading')[0].style.display = 'none';
		}

		if (err.response && err.response.status == 401 && err.response.data && err.response.data.error && err.response.data.error == 'Expired token') {
			console.log('Refescaremos el token, verificamos que tengamos el token de refresh');
			if (store.state.auth && store.state.auth.refreshToken) {
				let token = store.state.auth.refreshToken;

				console.log('Enviamos la solicitud para refrescar el token');
				return axios.post(process.env.VUE_APP_ACCOUNT_URL+'/auth/refresh', {token})
				.then(res => {
					if (res.data.token) {
						store.commit('refreshCredentials', res.data);

						err.config.headers.Authorization = 'Bearer '+res.data.token;

						return axios.request(err.config);
					}else {
						return Promise.reject(err);
					}
				})
			}else {
				return Promise.reject(err);
			}
		}else {
			return Promise.reject(err);
		}
	});

	return http;
}